import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { FaCheckCircle, FaHeart, FaGift, FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function NewYearWishSuccess() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { senderName, message } = location.state || {};

  const handleJoinJodiac = () => {
    // Jodiac'a katıl sayfasına yönlendir (bu sayfa henüz yok, ana sayfaya yönlendiriyoruz)
    window.open('https://jodi.ac', '_blank');
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-white">
      {/* Background Image Layer */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url(/assets/newyearbg.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.2,
        }}
      ></div>

      <div className="relative z-10 min-h-screen flex items-center justify-center">
        <div className="w-full max-w-md px-6">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            {/* Başarı İkonu */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20"></div>
                <div className="relative bg-gradient-to-br from-green-400 to-emerald-500 rounded-full p-6 shadow-2xl">
                  <FaCheckCircle className="w-16 h-16 text-white" />
                </div>
              </div>
            </div>

            {/* Başarı Mesajı */}
            <div className="mb-8">
              <h2 className="text-2xl sm:text-2xl font-bold text-gray-800 mb-3">
                Dileğiniz Başarıyla Gönderildi! 
              </h2>
              <p className="text-gray-700 text-base leading-relaxed">
                {senderName && (
                  <>
                    Dileğinizi aldık ve en kısa zamanda iletiyor olacağız. Mutlu yıllar!
                  </>
                )}
                {!senderName && 'Dileğiniz başarıyla gönderildi!'}
              </p>
            </div>

            {/* Gönderilen Mesaj Önizleme */}
            {message && (
              <div className="bg-white/80 border-2 border-gray-300 rounded-xl p-6 mb-8 opacity-50">
                <div className="flex items-start gap-4">
                  <div className="bg-gradient-to-br from-[#3DA7B5] to-[#5ABCC8] rounded-full p-3 flex-shrink-0">
                    <FaHeart className="w-5 h-5 text-white" />
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-800 text-sm leading-relaxed italic text-left">
                      "{message}"
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Butonlar */}
            <div className="space-y-4">
              <button
                onClick={handleJoinJodiac}
                className="w-full bg-gradient-to-r from-[#3DA7B5] to-[#5ABCC8] hover:from-[#2F8894] hover:to-[#4A9BA6] text-white rounded-lg py-4 px-6 flex items-center justify-center gap-3 font-semibold transition-all duration-300 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
              >
                <FaGift className="w-5 h-5" />
                <span>Sen de Jodiac'lı ol, sen de dilekler iste!</span>
                <FaArrowRight className="w-4 h-4" />
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

